<template>
	<!-- <nav>
		<router-link to="/">Main</router-link>
		<router-link to="/about">About</router-link>
		<router-link to="/about">ReferView</router-link>
		<router-link to="/about">YoutubeView</router-link>
		<router-link to="/about">UnsplashView</router-link>
		<router-link to="/about">About</router-link>
	</nav> -->
	<router-view />
</template>

<style lang="scss">
@import 'index.scss';
</style>
